import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgPriorityHigh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.25 16.75L9.25 6.1225L6.5575 8.8075L5.5 7.75L10 3.25L14.5 7.75L13.4425 8.8075L10.75 6.1225L10.75 16.75H9.25Z",
		fill: "inherit"
	})
});
export default SvgPriorityHigh;
